export const enum ProviderFilterPlace {
	BAR = 'bar',
	SETTINGS = 'settings',
	// EXP_PROVIDER_BUYBOX
	BUYBOX = 'buybox',
	// EXP_PROVIDER_BUYBOX
}
